import { render, staticRenderFns } from "./SingleSelectorInput.vue?vue&type=template&id=b0038eaa&scoped=true"
import script from "./SingleSelectorInput.vue?vue&type=script&lang=js"
export * from "./SingleSelectorInput.vue?vue&type=script&lang=js"
import style0 from "./SingleSelectorInput.vue?vue&type=style&index=0&id=b0038eaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0038eaa",
  null
  
)

export default component.exports